import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Alert, Badge, Button, Snackbar } from "@mui/material";
import { ShoppingCart } from "react-feather";
import { withCustomerAuth } from "../../../admin/components/GetAuth";
import { useWebsite } from "../../../context/WebsiteContext";
import { useSiteBranding } from "../../../hooks/useSiteBranding";
import ProductCatalogue from "../../../frontend/pages/shop/components/ProductCatalogue";
import ProductDetail from "../../../frontend/pages/shop/components/ProductDetail";
import AnnouncementBar from "../../../frontend/pages/shop/components/AnnouncementBar";
import { addToCart, openCartDrawer, useCartCount } from "../../../frontend/pages/shop/shopApi";
import shopStyles from "../../../frontend/pages/shop/shop.module.css";
import CustomerShell from "./CustomerShell";

// Shop Now in the customer panel (/customer/shop, /customer/shop/:id). The cart drawer lives in the panel header.
const CustomerShop = () => {
  const { id } = useParams();
  const { websiteData } = useWebsite();
  useSiteBranding("Shop Now", websiteData);
  const cartCount = useCartCount(true);
  const [addingId, setAddingId] = useState(0);
  const [error, setError] = useState("");

  const onAdd = (item, qty) => {
    setAddingId(item.id);
    addToCart(item.id, qty).then(() => {
      setAddingId(0);
      openCartDrawer();
    }).catch((e) => {
      setAddingId(0);
      setError(e.message);
    });
  };

  const cartButton = (<Button component={Link} to="/customer/shop/cart" onClick={(e) => { e.preventDefault(); openCartDrawer(); }} className={shopStyles.SecondaryBU} startIcon={<Badge badgeContent={cartCount} color="error"><ShoppingCart size={18} /></Badge>}>
    Cart
  </Button>);

  return (<>
    <AnnouncementBar text={websiteData?.shop_announcement} />
    <CustomerShell eyebrow="Shop Now" title={id ? null : "Shop Now"} sub="Order online and we deliver to your door." actions={cartButton}>
      <div className={shopStyles.Embedded}>
        {id ? <ProductDetail id={id} basePath="/customer/shop" onAdd={onAdd} adding={addingId > 0} /> : <ProductCatalogue basePath="/customer/shop" onAdd={onAdd} addingId={addingId} />}
      </div>

      <Snackbar open={error !== ""} autoHideDuration={5000} onClose={() => setError("")} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert severity="error" variant="filled" onClose={() => setError("")}>{error}</Alert>
      </Snackbar>
    </CustomerShell>
  </>);
};

export default withCustomerAuth(CustomerShop);
